import React, { useEffect } from 'react';
import { useSelector } from 'react-redux';
import {
  getDealFinderHasError,
  getDealFinderIsLoading
} from '@state/slices/deal-finder-results/dealFinderResultsSelectors';
import { PageTitle } from '@components/common/page-title';
import styled from '@emotion/styled';
import { ThemeProps } from '@theme/base';
import { useI18NextContext } from '@components/hooks';
import { mq } from '@styles/breakpoints';
import { rTapNumberHTML, rTapNotifyDOMChangeWrapper } from '@components/common/r-tap-number';

const Description = styled.p({});

const List = styled.ul(({ theme }: ThemeProps) => ({
  ...(theme.custom.typography.paragraph as any),
  li: {
    marginBottom: theme.custom.spacing.medium,
    '&:last-of-type': {
      marginBottom: 0
    }
  }
}));

export const Container = styled.div(({ theme }: ThemeProps) => ({
  marginTop: theme.custom.spacing.large,
  [mq.medium]: {
    marginTop: theme.custom.spacing.xxLarge,
    marginBottom: theme.custom.spacing.xxLarge
  }
}));

interface NoResultsProps {
  isBeforeLoad?: boolean;
}

export const NoResults = ({ isBeforeLoad }: NoResultsProps) => {
  const t: any = useI18NextContext();
  const isLoading: boolean = useSelector(getDealFinderIsLoading);
  const hasError: boolean = useSelector(getDealFinderHasError);
  useEffect(() => {
    if (!isLoading && hasError) {
      rTapNotifyDOMChangeWrapper();
    }
  }, []);

  if (isBeforeLoad || isLoading || !hasError) {
    return null;
  }

  const telephoneNumber = t('common__brand_telephone');
  return (
    <Container>
      <PageTitle
        heading={`${t('deal-finder__no-result--heading')} ${rTapNumberHTML({ telephoneNumber })}`}
        boldHeading
      />
      <Description>{t('deal-finder__no-result--body')}</Description>
      <List>
        <li>{t('deal-finder__no-result-list--1')}</li>
        <li>{t('deal-finder__no-result-list--2')}</li>
        <li>{t('deal-finder__no-result-list--3')}</li>
      </List>
    </Container>
  );
};
